module.exports = __webpack_public_path__ + "static/media/cat.3307aedb.png";